import React from 'react';

const PopularMeals = () => {
    return (
        <section className="popular" id="destination">
            <div className="container">
                <p className="section-subtitle">Uncover meal</p>
                <h2 className="h2 section-title">Popular Meals</h2>
                <p className="section-text">
                    Have a glance of our popular meals
                </p>
                <ul className="popular-list">
                    <li>
                        <div className="popular-card">
                            <figure className="card-img">
                                <img src="./assests/images/meal-1.jpg" alt="San miguel, italy" loading="lazy" />
                            </figure>
                            <div className="card-content">
                                <div className="card-rating">
                                    <ion-icon name="star"></ion-icon>
                                    <ion-icon name="star"></ion-icon>
                                    <ion-icon name="star"></ion-icon>
                                    <ion-icon name="star"></ion-icon>
                                    <ion-icon name="star"></ion-icon>
                                </div>
                                <h3 className="h3 card-title">
                                    <a href="https://atlanticcatering-gh.com/">ATLANTIC</a>
                                </h3>
                                <p className="card-text">
                                    Jollof Rice with Roasted Chicken
                                </p>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="popular-card">
                            <figure className="card-img">
                                <img src="./assests/images/meal-2.jpg" alt="Burj khalifa, dubai" loading="lazy" />
                            </figure>
                            <div className="card-content">
                                <div className="card-rating">
                                    <ion-icon name="star"></ion-icon>
                                    <ion-icon name="star"></ion-icon>
                                    <ion-icon name="star"></ion-icon>
                                    <ion-icon name="star"></ion-icon>
                                    <ion-icon name="star"></ion-icon>
                                </div>
                                
                                <h3 className="h3 card-title">
                                    <a href="https://atlanticcatering-gh.com/">ATLANTIC</a>
                                </h3>
                                <p className="card-text">
                                    Assorted Meat Fried Rice
                                </p>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="popular-card">
                            <figure className="card-img">
                                <img src="./assests/images/meal-4.jpg" alt="Kyoto temple, japan" loading="lazy" />
                            </figure>
                            <div className="card-content">
                                <div className="card-rating">
                                    <ion-icon name="star"></ion-icon>
                                    <ion-icon name="star"></ion-icon>
                                    <ion-icon name="star"></ion-icon>
                                    <ion-icon name="star"></ion-icon>
                                    <ion-icon name="star"></ion-icon>
                                </div>
                                <h3 className="h3 card-title">
                                    <a href="https://atlanticcatering-gh.com/">ATLANTIC</a>
                                </h3>
                                <p className="card-text">
                                    Rice served with Nkontomire Stew
                                </p>
                            </div>
                        </div>
                    </li>
                </ul>
                <button className="btn btn-primary">Checkout more</button>
            </div>
        </section>
    );
};

export default PopularMeals;
